import questionTypes from '../questionTypes';
import createEmptyRichTextCollection from '../../utils/createEmptyRichTextCollection';

import getCommonBlockProps, { commentsProps } from './getCommonBlockProps';
import { DEFAULT_MAX_OPTIONS_COUNT, DEFAULT_ROW_LABEL } from './constants';
import { STYLING_KEY_QUESTION_TEXT } from '../../constants/stylingKey';

export default {
  type: questionTypes.questionDropdown,
  getDefaultProps: () => ({
    ...getCommonBlockProps(),
    ...commentsProps,
    options: createEmptyRichTextCollection(1, DEFAULT_ROW_LABEL),
    label: 'Select option',
    labelEnabled: true,
  }),
  limits: {
    options: {
      max: DEFAULT_MAX_OPTIONS_COUNT,
      min: 1,
    },
  },
  settings: {
    defaultStylingEntity: STYLING_KEY_QUESTION_TEXT,
    isRequiredField: () => false,
    isUniqueField: () => false,
    isTextRequired: () => true,
  },
  toLogicOptions: questions =>
    questions.options.map(option => ({
      value: option.id,
      label: option.value,
    })),
};
